import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $asset, $http } from '@/axios';

// 查询已发布的导航
export const queryNavTrees: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  const timestamp = Date.now();
  const orgCode = payload.orgCode === 'platform' ? '' : payload.orgCode;
  const modNavName = orgCode ? `Model_${orgCode}` : 'Model';
  const matNavName = orgCode ? `Material_${orgCode}` : 'Material';
  const secNavName = orgCode ? `SectionProduct_${orgCode}` : 'SectionProduct';
  const promises: Array<Promise<any>> = payload.isPlatformUser
    ? [
      $asset('oss', `data/navigation_${modNavName}.json?t=${timestamp}`, { ignoreCodes: [404] }),
      $asset('oss', `data/navigation_${matNavName}.json?t=${timestamp}`, { ignoreCodes: [404] }),
      $asset('oss', `data/navigation_${secNavName}.json?t=${timestamp}`, { ignoreCodes: [404] }),
    ]
    : [
      $asset('oss', `data/navigation_Model.json?t=${timestamp}`, { ignoreCodes: [404] }),
      $asset('oss', `data/navigation_Material.json?t=${timestamp}`, { ignoreCodes: [404] }),
      $asset('oss', `data/navigation_SectionProduct.json?t=${timestamp}`, { ignoreCodes: [404] }),
      $asset('oss', `data/navigation_${modNavName}.json?t=${timestamp}`, { ignoreCodes: [404] }),
      $asset('oss', `data/navigation_${matNavName}.json?t=${timestamp}`, { ignoreCodes: [404] }),
      $asset('oss', `data/navigation_${secNavName}.json?t=${timestamp}`, { ignoreCodes: [404] }),
    ];

  commit('setNavTrees', { ...state.navTrees, loading: true });
  Promise.all(promises).then((results) => {
    const [
      sysModTrees = null,
      sysMatTrees = null,
      sysSecTrees = null,
      orgModTrees= null,
      orgMatTrees = null,
      orgSecTrees = null,
    ] = results || [];

    // 平台物品导航
    const sysModRoot = sysModTrees ? { id: -1, entityType: 'Model', ...sysModTrees, name: '物品' } : null;
    // 平台材料导航
    const sysMatRoot = sysMatTrees ? { id: -2, entityType: 'Material', ...sysMatTrees, name: '材料' } : null;
    // 平台型材产品导航
    const sysSecRoot = sysSecTrees ? { id: -3, entityType: 'SectionProduct', ...sysSecTrees, name: '型材产品' } : null;
    // 企业物品导航
    const orgModRoot = orgModTrees ? { id: -1, entityType: 'Model', ...orgModTrees, name: '物品' } : null;
    // 企业材料导航
    const orgMatRoot = orgMatTrees ? { id: -2, entityType: 'Material', ...orgMatTrees, name: '材料' } : null;
    // 企业型材产品导航
    const orgSecRoot = orgSecTrees ? { id: -3, entityType: 'SectionProduct', ...orgSecTrees, name: '型材产品' } : null;

    // 将物品，材料，型材产品组合成数组
    const sysRawData = [sysModRoot, sysMatRoot, sysSecRoot].filter((item) => !!item);
    const orgRawData = [orgModRoot, orgMatRoot, orgSecRoot].filter((item) => !!item);
    commit('setNavTrees', { systemRaw: sysRawData, orgRaw: orgRawData });
  }).catch(() => {
    commit('setNavTrees', { systemRaw: [], orgRaw: [] });
  });
};

// 查询物品或材料列表(图片列表)
export const queryMatImgList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const postMap: Record<string, string> = {
      Model: '/v1/data/asset/item/search',
      Material: '/v1/data/asset/material/search',
      SectionProduct: '/v1/data/asset/sectionproduct/search',
    };
    const { entity, navigationId, ...rest } = payload;
    const params = navigationId !== -1 ? { ...rest, navigationId } : rest;
    commit('setMatImgList', { ...state.imgList, loading: true });
    const res: IPageData = await $http.post(postMap[entity], params);
    const { list: data, pageNum, pageSize, total } = res;
    commit('setMatImgList', { data, pageNum, pageSize, total, params: payload });
   } catch (e) {
    commit('setMatImgList', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};
